
export const searchSuggestedData = [
 {
    "make": "Acura",
    "models": [
        "CSX",
        "ILX",
        "Integra",
        "MDX",
        "NSX",
        "RDX",
        "RL",
        "RLX",
        "TL",
        "TLX",
        "TSX",
        "ZDX"
    ]
},
{
    "make": "Alfa Romeo",
    "models": [
        "159",
        "4C",
        "Giulia",
        "Giulietta",
        "Mito",
        "Stelvio",
        "Tonale"
    ]
},
{
    "make": "Aston Martin",
    "models": [
        "DB11",
        "DB9",
        "DBS",
        "DBX",
        "DBX707",
        "One-77",
        "Rapide",
        "V12 Vantage",
        "V8 Vantage",
        "Vanquish",
        "Vantage",
        "Virage"
    ]
},
{
    "make": "Audi",
    "models": [
        "A1",
        "A3",
        "A3 e-tron",
        "A3 Quattro",
        "A3 Sportback e-tron",
        "A4",
        "A4 allroad",
        "A4 Quattro",
        "A5",
        "A5 Quattro",
        "A5 Sportback",
        "A6",
        "A6 allroad",
        "A6 Quattro",
        "A7",
        "A7 Quattro",
        "A7 Sportback",
        "A8",
        "A8 Quattro",
        "allroad",
        "e-tron GT",
        "e-tron",
        "e-tron S",
        "e-tron S Sportback",
        "e-tron Sportback",
        "Q2",
        "Q2 Quattro",
        "Q3",
        "Q3 Quattro",
        "Q4 e-tron",
        "Q4 e-tron Sportback",
        "Q5",
        "Q5 PHEV",
        "Q5 Sportback",
        "Q7",
        "Q8",
        "R8",
        "RS e-tron GT",
        "RS Q3",
        "RS Q8",
        "RS3",
        "RS5",
        "RS5 Sportback",
        "RS6",
        "RS6 Avant",
        "RS7",
        "RS7 Sportback",
        "S3",
        "S4",
        "S5",
        "S5 Sportback",
        "S6",
        "S7",
        "S7 Sportback",
        "S8",
        "SQ5",
        "SQ5 Sportback",
        "SQ7",
        "SQ8",
        "TT",
        "TT Quattro",
        "TT RS",
        "TT RS Quattro",
        "TTS",
        "TTS Quattro"
    ]
},
{
    "make": "BMW",
    "models": [
        "1 Series",
        "2 Series",
        "3 Series",
        "4 Series",
        "5 Series",
        "6 Series",
        "7 Series",
        "8 Series",
        "ActiveHybrid 3",
        "ActiveHybrid 5",
        "ActiveHybrid 7",
        "Alpina B6 Gran Coupe",
        "Alpina B6 xDrive Gran Coupe",
        "Alpina B7",
        "Alpina B7 xDrive",
        "Alpina B7L",
        "Alpina B7L xDrive",
        "Alpina B8 Gran Coupe",
        "Alpina XB7",
        "i3",
        "i3s",
        "i4",
        "i7",
        "i8",
        "iX",
        "iX xDrive40",
        "iX xDrive50",
        "iX3",
        "M135i",
        "M140i",
        "M2",
        "M235i",
        "M235i xDrive",
        "M235i xDrive Gran Coupe",
        "M240i",
        "M240i xDrive",
        "M3",
        "M340i",
        "M340i xDrive",
        "M4",
        "M440i",
        "M440i Gran Coupe",
        "M440i xDrive",
        "M440i xDrive Gran Coupe",
        "M5",
        "M550i xDrive",
        "M6",
        "M6 Gran Coupe",
        "M760i xDrive",
        "M760Li xDrive",
        "M8",
        "M8 Gran Coupe",
        "M850i xDrive",
        "M850i xDrive Gran Coupe",
        "X1",
        "X2",
        "X3",
        "X4",
        "X5",
        "X6",
        "X7",
        "Z4"
    ]
},
{
    "make": "Bentley",
    "models": [
        "Azure",
        "Bentayga",
        "Continental",
        "Flying Spur",
        "Mulsanne"
    ]
},
{
    "make": "Bugatti",
    "models": [
        "Chiron",
        "Divo",
        "Veyron 16.4"
    ]
},
{
    "make": "Buick",
    "models": [
        "Allure",
        "Cascada",
        "Enclave",
        "Enclave Avenir",
        "Encore",
        "Encore GX",
        "Envision",
        "LaCrosse",
        "Lucerne",
        "Regal",
        "Regal Sportback",
        "Regal TourX",
        "Verano"
    ]
},
{
    "make": "Cadillac",
    "models": [
        "ATS",
        "CT4",
        "CT5",
        "CT6",
        "CTS",
        "DTS",
        "ELR",
        "Escalade",
        "Escalade ESV",
        "Escalade EXT",
        "LYRIQ",
        "SRX",
        "STS",
        "XT4",
        "XT5",
        "XT6",
        "XTS"
    ]
},
{
    "make": "Chevrolet",
    "models": [
        "Captiva",
        "Avalanche",
        "Aveo",
        "Aveo5",
        "Beat",
        "Blazer",
        "Bolt EUV",
        "Bolt EV",
        "Camaro",
        "Caprice",
        "Captiva Sport",
        "Cavalier",
        "Chevy",
        "Cheyenne",
        "City Express",
        "Cobalt",
        "Colorado",
        "Corvette",
        "Cruze",
        "Cruze Limited",
        "Cruze NG",
        "Equinox",
        "Express 1500",
        "Express 2500",
        "Express 3500",
        "Express 4500",
        "Express Cargo",
        "Express Pasajeros",
        "Groove",
        "HHR",
        "Impala",
        "Impala Limited",
        "LCF 3500",
        "LCF 3500HD",
        "LCF 4500",
        "LCF 4500HD",
        "LCF 4500XD",
        "LCF 5500HD",
        "LCF 5500XD",
        "LCF 6500XD",
        "Malibu",
        "Malibu Limited",
        "Matiz",
        "Nuevo Aveo",
        "Onix",
        "Optra",
        "Orlando",
        "S10",
        "Silverado",
        "Sonic",
        "Spark",
        "Spark Classic",
        "Spark EV",
        "SS",
        "Suburban",
        "Suburban 1500",
        "Suburban 2500",
        "Suburban 3500 HD",
        "Tahoe",
        "Tornado",
        "Tornado Van",
        "Tracker",
        "Trailblazer",
        "Traverse",
        "Trax",
        "Volt",
        "W4500 Tiltmaster",
        "W5500 Tiltmaster"
    ]
},
{
    "make": "Chrysler",
    "models": [
        "200",
        "300",
        "Cirrus",
        "Grand Caravan",
        "Pacifica",
        "PT Cruiser",
        "Sebring",
        "Town & Country",
        "Voyager"
    ]
},
{
    "make": "Dodge",
    "models": [
        "Atos",
        "Attitude",
        "Avenger",
        "Caliber",
        "Challenger",
        "Charger",
        "Dakota",
        "Dart",
        "Durango",
        "H100",
        "H100 Van",
        "Hornet",
        "i10",
        "Journey",
        "Neon",
        "Nitro",
        "Ram 1500",
        "Ram 2500",
        "Ram 3500",
        "Ram 4000",
        "Ram 4500",
        "Ram 5500",
        "Viper",
        "Vision"
    ]
},
{
    "make": "Ferrari",
    "models": [
        "296 GTB",
        "458 Italia",
        "458 Speciale",
        "458 Spider",
        "488 GTB",
        "488 Pista",
        "488 Pista Spider",
        "488 Spider",
        "599 GTB",
        "599 GTO",
        "612 Scaglietti",
        "812 GTS",
        "812 Superfast",
        "California",
        "California T",
        "F12 Berlinetta",
        "F12tdf",
        "F8 Spider",
        "F8 Tributo",
        "FF",
        "GTC4Lusso",
        "GTC4Lusso T",
        "LaFerrari",
        "Portofino",
        "Portofino M",
        "Roma",
        "SF90 Spider",
        "SF90 Stradale"
    ]
},
{
    "make": "Fiat",
    "models": [
        "500",
        "124 Spider",
        "500L",
        "500X",
        "Albea",
        "Argo",
        "Ducato",
        "Linea",
        "Mobi",
        "Palio",
        "Panda",
        "Punto",
        "Strada",
        "Uno",
        "JOLLY",
        "500C",
        "500E"
    ]
},
{
    "make": "Fisker",
    "models": [
        "Karma",
        "OCEAN"
    ]
},
{
    "make": "Ford",
    "models": [
        "Bronco",
        "Bronco Sport",
        "C-Max",
        "Courier",
        "Crown Victoria",
        "E-150",
        "E-250",
        "E-350 Super Duty",
        "E-450 Super Duty",
        "E-Transit",
        "Econoline Van",
        "Econoline Wagon",
        "EcoSport",
        "Edge",
        "Escape",
        "Expedition",
        "Explorer",
        "Explorer Sport Trac",
        "F-150",
        "F-150 Lightning",
        "F-250",
        "F-250 Super Duty",
        "F-350",
        "F-350 Super Duty",
        "F-450",
        "F-450 Super Duty",
        "F-550 Super Duty",
        "F-600 Super Duty",
        "F53",
        "F59",
        "F650",
        "F750",
        "Fiesta",
        "Fiesta Ikon",
        "Figo",
        "Flex",
        "Focus",
        "Fusion",
        "GT",
        "LCF",
        "Lobo",
        "Maverick",
        "Mustang",
        "Mustang Mach-E",
        "Police Interceptor Sedan",
        "Police Interceptor Utility",
        "Police Responder Hybrid",
        "Ranger",
        "Special Service Police Sedan",
        "SSV Plug-In Hybrid",
        "Taurus",
        "Transit",
        "Transit Connect",
        "Transit Courier",
        "Transit Custom",
        "Transit-150",
        "Transit-250",
        "Transit-350",
        "Transit-350 HD",
        "SHELBY"
    ]
},
{
    "make": "GMC",
    "models": [
        "Acadia",
        "Acadia Limited",
        "Canyon",
        "Hummer EV",
        "Savana",
        "Savana 1500",
        "Savana 2500",
        "Savana 3500",
        "Savana 4500",
        "Sierra",
        "Sierra 1500",
        "Sierra 1500 Limited",
        "Sierra 2500 HD",
        "Sierra 3500 HD",
        "Terrain",
        "W4500 Forward",
        "W5500 Forward",
        "Yukon",
        "Yukon XL",
        "Yukon XL 1500",
        "Yukon XL 2500"
    ]
},
{
    "make": "Genesis",
    "models": [
        "G70",
        "G80",
        "G90",
        "GV70",
        "GV80",
        "GV60"
    ]
},
{
    "make": "Honda",
    "models": [
        "Accord",
        "Accord Crosstour",
        "BR-V",
        "City",
        "Civic",
        "Clarity",
        "Clarity Plug-In Hybrid",
        "CR-V",
        "CR-Z",
        "Crosstour",
        "Element",
        "Fit",
        "HR-V",
        "Insight",
        "Odyssey",
        "Passport",
        "Pilot",
        "Ridgeline"
    ]
},
{
    "make": "Hummer",
    "models": [
        "H3",
        "H3T"
    ]
},
{
    "make": "Hyundai",
    "models": [
        "Accent",
        "Azera",
        "Creta",
        "Creta Grand",
        "Elantra",
        "Elantra Coupe",
        "Elantra GT",
        "Elantra N",
        "Entourage",
        "Equus",
        "EX6",
        "EX8",
        "Genesis",
        "Genesis Coupe",
        "Grand i10",
        "H200",
        "H300",
        "H400",
        "H500",
        "HD55",
        "HD65",
        "HD78",
        "Ioniq",
        "Ioniq 5",
        "ix35",
        "Kona",
        "Kona Electric",
        "Kona N",
        "Nexo",
        "Palisade",
        "Santa Cruz",
        "Santa Fe",
        "Santa Fe XL",
        "Sonata",
        "Starex",
        "Tucson",
        "Veloster",
        "Veloster N",
        "Venue",
        "Veracruz"
    ]
},
{
    "make": "Infiniti",
    "models": [
        "EX35",
        "EX37",
        "FX35",
        "FX37",
        "FX50",
        "G25",
        "G37",
        "JX35",
        "M35",
        "M35h",
        "M37",
        "M45",
        "M56",
        "Q40",
        "Q50",
        "Q60",
        "Q70",
        "Q70L",
        "QX30",
        "QX50",
        "QX55",
        "QX56",
        "QX60",
        "QX70",
        "QX80",
        "G35"
    ]
},
{
    "make": "Isuzu",
    "models": [
        "ELF 100",
        "ELF 200",
        "ELF 300",
        "ELF 400",
        "ELF 500",
        "ELF 600",
        "ELF 600-BUS",
        "Forward 1100",
        "Forward 1400",
        "Forward 800",
        "FTR",
        "FVR",
        "FXR",
        "NPR",
        "NPR-HD",
        "NPR-XD",
        "NQR",
        "NRR",
        "Reach"
    ]
},
{
    "make": "Jaguar",
    "models": [
        "E-Pace",
        "F-Pace",
        "F-Type",
        "I-Pace",
        "XE",
        "XF",
        "XFR",
        "XFR-S",
        "XJ",
        "XJR",
        "XJR575",
        "XK",
        "XKR",
        "XKR-S"
    ]
},
{
    "make": "Jeep",
    "models": [
        "Cherokee",
        "Commander",
        "Compass",
        "Gladiator",
        "Grand Cherokee",
        "Grand Cherokee L",
        "Grand Cherokee WK",
        "Grand Wagoneer",
        "Liberty",
        "Patriot",
        "Renegade",
        "Wagoneer",
        "Wrangler",
        "Wrangler JK"
    ]
},
{
    "make": "Kia",
    "models": [
        "Borrego",
        "Cadenza",
        "Carnival",
        "EV6",
        "Forte",
        "Forte Koup",
        "Forte5",
        "K5",
        "K900",
        "Magentis",
        "Niro",
        "Niro EV",
        "Optima",
        "Rio",
        "Rio5",
        "Rondo",
        "Sedona",
        "Seltos",
        "Sorento",
        "Soul",
        "Soul EV",
        "Sportage",
        "Stinger",
        "Telluride"
    ]
},
{
    "make": "Lamborghini",
    "models": [
        "Aventador",
        "Centenario",
        "Gallardo",
        "Huracan",
        "Murcielago",
        "Urus",
        "Veneno"
    ]
},
{
    "make": "Land Rover",
    "models": [
        "Defender",
        "Defender 110",
        "Defender 130",
        "Defender 90",
        "Discovery",
        "Discovery Sport",
        "LR2",
        "LR4",
        "Range Rover",
        "Range Rover Evoque",
        "Range Rover Sport",
        "Range Rover Velar"
    ]
},
{
    "make": "Lexus",
    "models": [
        "CT200h",
        "ES250",
        "ES300h",
        "ES350",
        "GS F",
        "GS200t",
        "GS300",
        "GS350",
        "GS450h",
        "GS460",
        "GX460",
        "HS250h",
        "IS F",
        "IS200t",
        "IS250",
        "IS300",
        "IS350",
        "IS500",
        "LC500",
        "LC500h",
        "LFA",
        "LS460",
        "LS500",
        "LS500h",
        "LS600h",
        "LX570",
        "LX600",
        "NX200t",
        "NX250",
        "NX300",
        "NX300h",
        "NX350",
        "NX350h",
        "NX450h+",
        "RC F",
        "RC200t",
        "RC300",
        "RC350",
        "RX350",
        "RX350L",
        "RX450h",
        "RX450hL",
        "SC430",
        "UX200",
        "UX250h",
        "CT200"
    ]
},
{
    "make": "Lincoln",
    "models": [
        "Aviator",
        "Corsair",
        "Mark LT",
        "MKC",
        "MKS",
        "MKT",
        "MKX",
        "MKZ",
        "Nautilus",
        "Navigator",
        "Town Car"
    ]
},
{
    "make": "Lotus",
    "models": [
        "Elise",
        "Emira",
        "Evora",
        "Evora GT",
        "Exige"
    ]
},
{
    "make": "Lucid",
    "models": [
        "Air"
    ]
},
{
    "make": "Maserati",
    "models": [
        "Ghibli",
        "GranCabrio",
        "GranTurismo",
        "Grecale",
        "Levante",
        "MC20",
        "Quattroporte"
    ]
},
{
    "make": "Maybach",
    "models": [
        "57",
        "62"
    ]
},
{
    "make": "Mazda",
    "models": [
        "2",
        "3",
        "5",
        "6",
        "3 Sport",
        "B2300",
        "B4000",
        "CX-3",
        "CX-30",
        "CX-5",
        "CX-50",
        "CX-7",
        "CX-9",
        "MX-30 EV",
        "MX-5",
        "MX-5 Miata",
        "RX-8",
        "Tribute",
        "CX-90"
    ]
},
{
    "make": "McLaren",
    "models": [
        "540C",
        "570GT",
        "570S",
        "600LT",
        "650S",
        "675LT",
        "720S",
        "765LT",
        "Artura",
        "MP4-12C",
        "P1"
    ]
},
{
    "make": "Mercedes-Benz",
    "models": [
        "A-Class",
        "Allegro",
        "Alliado",
        "AMG-Class",
        "Andare",
        "B Electric Drive",
        "B-Class",
        "Boxer 40",
        "Boxer 50",
        "Boxer 60",
        "Boxer OF",
        "Busstar 380",
        "C-Class",
        "CL-Class",
        "CLA-Class",
        "CLS-Class",
        "Coraza S2",
        "E-Class",
        "EQA300",
        "EQC400",
        "FS65",
        "G-Class",
        "GL-Class",
        "GLA-Class",
        "GLB-Class",
        "GLC-Class",
        "GLE-Class",
        "GLK-Class",
        "GLS-Class",
        "Gran Viale",
        "Gran Viale Articulado",
        "Gran Viale LE",
        "Gran Viale RF",
        "HDX",
        "LO 916",
        "Marco Polo",
        "Maybach GLS600",
        "Maybach S550",
        "Maybach S560",
        "Maybach S580",
        "Maybach S600",
        "Maybach S650",
        "Maybach S680",
        "MBO 1018",
        "MBO 12000",
        "MBO 1218",
        "MBO 1221",
        "MBO 14000",
        "MBO 1421",
        "Metris",
        "M-Class",
        "MP60 Express",
        "Multego",
        "O500",
        "OC 500",
        "OF 1118",
        "OF 1318",
        "OF 1321",
        "OH 1500",
        "OH 1518",
        "OH 1524",
        "OH 1600",
        "OH 1621",
        "OH 1624",
        "OH 1625",
        "OMC 1400",
        "Paradiso 1200",
        "Paradiso 1350",
        "Paradiso 1800",
        "R-Class",
        "S-Class",
        "Safety Bus",
        "SL-Class",
        "SLC-Class",
        "SLK-Class",
        "SLS-Class",
        "Sprinter",
        "Toreto 45",
        "Toreto 48",
        "Torino",
        "Tres Ejes",
        "V220d",
        "V250",
        "Viaggio 1050",
        "Viaggio 900",
        "Viale BRT",
        "Viano",
        "Vito",
        "EQB",
        "EQE",
        "EQS"
    ]
},
{
    "make": "Mercury",
    "models": [
        "Grand Marquis",
        "Mariner",
        "Milan",
        "Mountaineer"
    ]
},
{
    "make": "Mini",
    "models": [
        "Cooper",
        "Cooper Clubman",
        "Cooper Countryman",
        "Cooper Paceman",
        "Convertible"
    ]
},
{
    "make": "Mitsubishi",
    "models": [
        "ASX",
        "Eclipse",
        "Eclipse Cross",
        "Endeavor",
        "Galant",
        "i-MiEV",
        "L200",
        "Lancer",
        "Mirage",
        "Mirage G4",
        "Montero",
        "Montero Sport",
        "Outlander",
        "Outlander PHEV",
        "Outlander Sport",
        "RVR",
        "Xpander"
    ]
},
{
    "make": "Nissan",
    "models": [
        "370Z",
        "Altima",
        "Aprio",
        "Ariya",
        "Armada",
        "Cabstar",
        "Cube",
        "Frontier",
        "GT-R",
        "Juke",
        "Kicks",
        "Kicks e-Power",
        "Leaf",
        "March",
        "Maxima",
        "Micra",
        "Murano",
        "Note",
        "NP 300",
        "NP 300 Frontier",
        "NT 400 Cabstar",
        "NV 1500",
        "NV 200",
        "NV 2500",
        "NV 350 Urvan",
        "NV 3500",
        "Pathfinder",
        "Pickup",
        "Platina",
        "Qashqai",
        "Quest",
        "Rogue",
        "Rogue Select",
        "Rogue Sport",
        "Sentra",
        "Tiida",
        "Titan",
        "Titan XD",
        "Tsuru",
        "Urvan",
        "V-Drive",
        "Versa",
        "Versa Note",
        "X-Trail",
        "Xterra",
        "Z"
    ]
},
{
    "make": "Porsche",
    "models": [
        "911",
        "718 Boxster",
        "718 Cayman",
        "718 Spyder",
        "918 Spyder",
        "Boxster",
        "Cayenne",
        "Cayman",
        "Macan",
        "Panamera",
        "Taycan"
    ]
},
{
    "make": "Ram",
    "models": [
        "700",
        "1500",
        "2500",
        "3500",
        "4000",
        "4500",
        "5500",
        "1500 Classic",
        "DAKOTA",
        "C/V",
        "ProMaster 1500",
        "ProMaster 2500",
        "ProMaster 3500",
        "ProMaster City",
        "ProMaster Rapid"
    ]
},
{
    "make": "Rolls-Royce",
    "models": [
        "Cullinan",
        "Dawn",
        "Ghost",
        "Phantom",
        "Wraith"
    ]
},
{
    "make": "Saab",
    "models": [
        "9-3",
        "9-3X",
        "9-4",
        "9-4X",
        "9-5X",
        "9-5"
    ]
},
{
    "make": "Scion",
    "models": [
        "FR-S",
        "iA",
        "iM",
        "iQ",
        "tC",
        "xB",
        "xD"
    ]
},
{
    "make": "Smart",
    "models": [
        "EQ fortwo",
        "Forfour",
        "Fortwo"
    ]
},
{
    "make": "Subaru",
    "models": [
        "Ascent",
        "BRZ",
        "Crosstrek",
        "Forester",
        "Impreza",
        "Legacy",
        "Outback",
        "Solterra",
        "Tribeca",
        "WRX",
        "WRX STI",
        "XV",
        "XV Crosstrek"
    ]
},
{
    "make": "Suzuki",
    "models": [
        "Baleno",
        "Ciaz",
        "Equator",
        "Ertiga",
        "Grand Vitara",
        "Ignis",
        "Jimny",
        "Kizashi",
        "S-Cross",
        "Swift",
        "Swift+",
        "SX4",
        "SX4 Crossover",
        "Vitara"
    ]
},
{
    "make": "Tesla",
    "models": [
        "Model 3",
        "Roadster",
        "Model S",
        "Model X",
        "Model Y"
    ]
},
{
    "make": "Toyota",
    "models": [
        "86",
        "4Runner",
        "Avalon",
        "Avanza",
        "bZ4X",
        "C-HR",
        "Camry",
        "Corolla",
        "Corolla Cross",
        "Corolla iM",
        "FJ Cruiser",
        "GR 86",
        "GR Corolla",
        "GR Supra",
        "GR86",
        "Hiace",
        "Highlander",
        "Hilux",
        "Land Cruiser",
        "Matrix",
        "Mirai",
        "Prius",
        "Prius AWD-e",
        "Prius C",
        "Prius Plug-In",
        "Prius Prime",
        "Prius V",
        "Raize",
        "RAV4",
        "RAV4 Prime",
        "Sequoia",
        "Sienna",
        "SCION",
        "SCION FR-S",
        "Supra",
        "Tacoma",
        "Tundra",
        "Venza",
        "Yaris",
        "Yaris iA",
        "Yaris R",
        "Crown"
    ]
},
{
    "make": "Volkswagen",
    "models": [
        "Amarok",
        "Arteon",
        "Atlas",
        "Atlas Cross Sport",
        "Beetle",
        "Beetle Cabrio",
        "Bora",
        "Caddy",
        "CC",
        "Clasico",
        "Combi",
        "Constellation",
        "Crafter",
        "Crafter Van",
        "Cross Sport",
        "CrossFox",
        "Delivery",
        "e-Golf",
        "Eos",
        "GLI",
        "Gol",
        "Gol Sedan",
        "Golf",
        "Golf Alltrack",
        "Golf City",
        "Golf R",
        "Golf SportWagen",
        "GTI",
        "ID.4",
        "Jetta",
        "Multivan",
        "Nivus",
        "Nuevo Gol",
        "Passat",
        "Passat CC",
        "Pointer Truck",
        "Polo",
        "Robust",
        "Routan",
        "Saveiro",
        "SportVan",
        "T-Cross",
        "Taos",
        "Teramont",
        "Tiguan",
        "Tiguan Limited",
        "Touareg",
        "Transporter",
        "Up!",
        "Vento",
        "Virtus",
        "Volksbus",
        "Worker",
        "Workline",
        "Vanagon"
    ]
},
{
    "make": "Volvo",
    "models": [
        "7900",
        "8300",
        "9700",
        "9800",
        "7300 BRT",
        "9700 Grand",
        "Access",
        "ALD Enviro500",
        "B11R",
        "B13R",
        "B290R",
        "B410R",
        "B8R",
        "B8RLE",
        "C30",
        "C40",
        "C70",
        "Hibrido",
        "ProCity",
        "S40",
        "S60",
        "S60 Cross Country",
        "S80",
        "S90",
        "V40",
        "V40 Cross Country",
        "V50",
        "V60",
        "V60 Cross Country",
        "V70",
        "V90",
        "V90 Cross Country",
        "VAH",
        "VAH 300",
        "VAH 400",
        "VAH 430",
        "VAH 640",
        "VHD",
        "VNL",
        "VNL 300",
        "VNL 400",
        "VNL 430",
        "VNL 630",
        "VNL 670",
        "VNL 740",
        "VNL 760",
        "VNL 860",
        "VNM",
        "VNR",
        "VNR 300",
        "VNR 400",
        "VNR 640",
        "VNX",
        "VT",
        "XC40",
        "XC40 Recharge",
        "XC60 Recharge",
        "XC60",
        "XC70",
        "XC90",
        "XC90 Recharge"
    ]
}
]